// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";   // ✅ IMPORTANT
import { getStorage } from "firebase/storage"; 


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD5PzuCku1B9etdT1b8ui-bZyq__dXgoy0",
  authDomain: "chawaltaka-store.firebaseapp.com",
  projectId: "chawaltaka-store",
  storageBucket: "chawaltaka-store.firebasestorage.app",
  messagingSenderId: "1084684019899",
  appId: "1:1084684019899:web:997649a296677f2e77219e",
  measurementId: "G-VSZJFXMJN5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize modules
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); 

// ✅ IMPORTANT — Updated to Mumbai Server (asia-south1)
export const functions = getFunctions(app, "asia-south1");

// Default export
export default app;